import React from "react";
import { Box, Lists, IconButton, SpacedPaper, Tabs } from "@fedsim/components";
import { reduceByKey } from "@fedsim/helpers";

import { useWrestlers } from "contexts/Wrestler";
import { useChampionships } from "contexts/Championship";
import { useShows } from "contexts/Show";
import { useFactions } from "contexts/Faction";
import { useProductions } from "contexts/Production";
import Modal from "components/modal";

import QuicklookIcon from '@mui/icons-material/Search';

import { sortByPoints } from "selectors";

const style = {
  position: 'absolute',
  top: '50%',
  height: "90%",
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "90%",
  maxWidth: 1200,
  minWidth: 300,
  bgcolor: 'background.paper',
  // boxShadow: 12,
  p: 2,
  overflow: 'scroll'
};

const listProps = {
  toggleListType: true,
  searchEnabled: true,
  sortEnabled: false,
  defaultListType: "card",
};

interface FilesInterface {
  collection?: any[];
  maxHeight?: number | string;
}

export function Files({
  collection = [],
}: FilesInterface): JSX.Element {
  return (
    <Box sx={style}>
      <Tabs collection={collection} />
    </Box>
  );
}

function Wrapper({ children = null }) {
  return (
    <SpacedPaper>{children}</SpacedPaper>
  )
}
export function Content() {
  // collections
  const sortByFirstBrand = (a, b) => b?.brandIds?.[0].localeCompare(a?.brandIds?.[0]);
  const { imported: productions } = useProductions();
  const { imported: championships } = useChampionships();
  const { imported: rawWrestlers } = useWrestlers();
  const { imported: shows } = useShows();
  const { imported: factions } = useFactions();
  // filtered
  const championIds = reduceByKey("wrestlerIds", championships);
  const champions = rawWrestlers.filter((item) => championIds.includes(item.id)).sort(sortByFirstBrand);
  const wrestlers = rawWrestlers.sort(sortByPoints);

  const collection = [
    {
      value: 0,
      label: `Wrestlers (${wrestlers?.length})`,
      PresentationItem: () => <Wrapper><Lists collection={wrestlers} groupName="Wrestler" {...listProps} /></Wrapper>,
    },
    {
      value: 1,
      label: `Championships (${championships?.length})`,
      PresentationItem: () => <Wrapper><Lists collection={championships} groupName="Championship" {...listProps} /></Wrapper>,
    },
    {
      value: 2,
      label: `Productions (${productions?.length})`,
      PresentationItem: () => <Wrapper><Lists collection={productions} groupName="Production" {...listProps} /></Wrapper>,
    },
    {
      value: 3,
      label: `Shows (${shows?.length})`,
      PresentationItem: () => <Wrapper><Lists collection={shows} groupName="Show" {...listProps} /></Wrapper>,
    },
    {
      value: 4,
      label: `Champions (${champions?.length})`,
      PresentationItem: () => <Wrapper><Lists collection={champions} groupName="Wrestler" {...listProps} /></Wrapper>,
    },
    {
      id: 5,
      label: `Factions (${factions?.length})`,
      PresentationItem: () => <Wrapper><Lists collection={factions} groupName="Faction" {...listProps} /></Wrapper>,
    },
  ];

  return <Files collection={collection} />;
}

export function Toggle({ onClick }) {
  return (
    <IconButton onClick={onClick} color="inherit">
      <QuicklookIcon />
    </IconButton>
  );
}

export function OpenFiles({ children = <></> }) {
  return (
    <Modal Content={Content} Toggle={Toggle}>
      {children}
    </Modal>
  );
}
export default OpenFiles;
